<div class="row align-items-center">
    <div class="col-4">
        <div class="font-weight-bold">{{ shipmentAttachment.filename }}</div>
        <div>{{ shipmentAttachment.description }}</div>
    </div>
    <div class="col d-flex justify-content-center">
        <fa-icon
            class="text-primary"
            size="3x"
            *ngIf="!canShowThumbnail"
            [icon]="['fas', 'file']">
        </fa-icon>
        <img
            *ngIf="canShowThumbnail && shipmentAttachment?.attachment_link?.data?.url"
            class="rounded thumbnail"
            [src]="shipmentAttachment?.attachment_link?.data?.url"
            width="146"
            height="110"
            [alt]="shipmentAttachment.description"
            [pTooltip]="shipmentAttachment.description"
            (click)="openGallery()" />
    </div>
    <div class="col-2">
        <div>{{ shipmentAttachment.created_at | amTimeAgo }}</div>
    </div>
    <div class="col-2 text-right">
        <button
            (click)="onDownloadAttachment()"
            [disabled]="disabled || shouldDisableDownloadButton"
            class="btn btn-link download"
            pTooltip="{{ 'portal.common.download-attachment' | translate }}"
            [tooltipPosition]="'left'"
        >
            <fa-icon [icon]="['far', 'cloud-download']"></fa-icon>
        </button>
        <button
            (click)="onDeleteAttachment()"
            [disabled]="disabled"
            class="btn btn-link delete"
            pTooltip="{{ 'portal.common.delete-attachment' | translate }}"
            [tooltipPosition]="'left'"
            *ngIf="canDelete"
        >
            <fa-icon [icon]="['far', 'trash']" class="text-danger"></fa-icon>
        </button>
    </div>
</div>

<p-dialog [modal]="true" [(visible)]="showDeleteAttachmentModal" [style]="{ width: '400px' }" [showHeader]="false" [dismissableMask]="true">
    <div class="modal-header border-bottom-0 px-4 pt-4" >
        <h5 class="modal-title" id="modal-basic-title">{{ 'portal.common.delete-attachment' | translate }}</h5>
    </div>
    <div class="modal-body px-4">
        <div class="message">{{ 'portal.common.delete-attachment-alt' | translate : { value: shipmentAttachment.filename } }}</div>
    </div>
    <div class="modal-footer border-top-0 pt-0 px-4 pb-4">
        <button class="confirm btn btn-danger" (click)="confirmAction()">
            {{ 'common.yes' | translate }}
        </button>
        <button class="dismiss btn btn-light" (click)="cancelAction()">
            {{ 'common.no' | translate }}
        </button>
    </div>
</p-dialog>
